import { render, staticRenderFns } from "./RequestReturnGoodsFilter.vue?vue&type=template&id=cd56770c&scoped=true"
import script from "./RequestReturnGoodsFilter.vue?vue&type=script&lang=js"
export * from "./RequestReturnGoodsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd56770c",
  null
  
)

export default component.exports